import { EInternalPackageType } from '../../types';
import { EPaymentProvider } from '../../types/microfrontends/paymentWidget';
import { PaymentEvent } from './event';

export const paymentSuccess = (
  internalPackageType: EInternalPackageType,
  paymentId?: string,
  provider?: EPaymentProvider,
) => {
  const event = new PaymentEvent('payment-success', { internalPackageType, paymentId, provider });

  event.dispatch();
};
